import React, { useEffect, useState, useRef } from "react";
import axios from "axios";

const KitchenList = () => {
  const [kitchens, setKitchens] = useState([]);
  const [operators, setOperators] = useState([]);
  const [assignments, setAssignments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedOperator, setSelectedOperator] = useState({});
  const [search, setSearch] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [selectedKitchenIdForEdit, setSelectedKitchenIdForEdit] =
    useState(null);

  const [showModal, setShowModal] = useState(false);
  const [selectedKitchenId, setSelectedKitchenId] = useState(null);
  const [formData, setFormData] = useState({
    kitchen_name: "",
    contact_person: "",
    contact_no: "",
    kitchen_address: "",
    kitchen_location: "",
    district: "",
    state: "",
    user_name: "",
    password: "",
  });

  const assignModalRef = useRef(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [kitchenRes, operatorRes, assignmentRes] = await Promise.all([
        axios.get("https://ims-backend.indevconsultancy.in/api/kitchens/"),
        axios.get(
          "https://ims-backend.indevconsultancy.in/admin-panel/operators/"
        ),
        axios.get(
          "https://ims-backend.indevconsultancy.in/admin-panel/assignments/"
        ),
      ]);
      setKitchens(kitchenRes.data);
      setOperators(operatorRes.data);
      setAssignments(assignmentRes.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  const handleAssignClick = (kitchenId) => {
    setSelectedKitchenId(kitchenId);
    setSelectedOperator({});
    const modal = new window.bootstrap.Modal(assignModalRef.current);
    modal.show();
  };

  const handleOperatorChange = (e) => {
    setSelectedOperator({ operator_id: e.target.value });
  };

  //   const handleAssignSubmit = async () => {
  //     try {
  //       await axios.post('https://ims-backend.indevconsultancy.in/admin-panel/assign-kitchens/', {
  //         kitchen_id: selectedKitchenId,
  //         operator_id: selectedOperator.operator_id,
  //       });
  //       alert('Operator assigned successfully!');
  //       const modalInstance = window.bootstrap.Modal.getInstance(assignModalRef.current);
  //       modalInstance.hide();
  //       fetchData();
  //     } catch (error) {
  //       console.error('Error assigning operator:', error);
  //       alert('Failed to assign operator');
  //     }
  //   };

  const handleAssignSubmit = async () => {
    if (!selectedKitchenId) {
      alert("Please select a valid kitchen.");
      return;
    }

    try {
      await axios.post(
        "https://ims-backend.indevconsultancy.in/admin-panel/assign-kitchens/",
        {
          kitchen_id: selectedKitchenId,
          operator_id: selectedOperator.operator_id,
        }
      );
      alert("Operator assigned successfully!");
      setShowModal(false);
      fetchData();
    } catch (error) {
      console.error("Error assigning operator:", error);
      alert("Failed to assign operator");
    }
  };

  //   const getAssignedOperatorName = (kitchenId) => {
  //     const assignment = assignments.find(a => a.kitchen_id === kitchenId);
  //     return assignment ? assignment.name : null;
  //   };

  const getAssignedOperatorName = (kitchenId) => {
    if (!kitchenId) return "No kitchen assigned"; // Handle null or undefined kitchen_id
    const assignment = assignments.find((a) => a.kitchen_id === kitchenId);
    return assignment ? assignment.name : null;
  };

  const filteredKitchens = kitchens.filter((kitchen) =>
    kitchen.kitchen_name.toLowerCase().includes(search.toLowerCase())
  );

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const paginatedKitchens = filteredKitchens.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  const totalPages = Math.ceil(filteredKitchens.length / itemsPerPage);

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // const handleAddKitchen = async (e) => {
  //   e.preventDefault();
  //   try {
  //     await axios.post(
  //       "https://ims-backend.indevconsultancy.in/api/addkitchen/",
  //       formData
  //     );
  //     alert("Kitchen added successfully!");
  //     setFormData({
  //       kitchen_name: "",
  //       contact_person: "",
  //       contact_no: "",
  //       kitchen_address: "",
  //       kitchen_location: "",
  //       user_name: "",
  //       password: "",
  //     });
  //     fetchData();
  //   } catch (error) {
  //     console.error("Error adding kitchen:", error);
  //     alert("Failed to add kitchen");
  //   }
  // };

  const handleAddKitchen = async (e) => {
    e.preventDefault();
    try {
      if (editMode) {
        await axios.put(
          `https://ims-backend.indevconsultancy.in/api/kitchens/${selectedKitchenIdForEdit}/`,
          formData
        );
        alert("Kitchen updated successfully!");
      } else {
        const res = await axios.post(
          "https://ims-backend.indevconsultancy.in/api/addkitchen/",
          formData
        );
        // Backend returns HTTP 200 even when it does NOT create the kitchen
        // (e.g. duplicate username). A real success includes an `id`; without
        // it, surface the actual message and keep the modal open to fix it.
        if (!res?.data?.id) {
          const msg = (res?.data?.msg || "").toLowerCase();
          alert(
            msg.includes("exit") || msg.includes("exist")
              ? "This username already exists. Please choose a different username."
              : res?.data?.msg || "Failed to add kitchen"
          );
          return;
        }
        alert("Kitchen added successfully!");
      }

      setFormData({
        kitchen_name: "",
        contact_person: "",
        contact_no: "",
        kitchen_address: "",
        kitchen_location: "",
        district: "1",
        state: "1",
        user_name: "",
        password: "",
      });
      setEditMode(false);
      setSelectedKitchenIdForEdit(null);
      fetchData();

      const modal = window.bootstrap.Modal.getInstance(
        document.getElementById("addKitchenModal")
      );
      if (modal) modal.hide();
    } catch (error) {
      console.error("Error saving kitchen:", error);
      alert("Failed to save kitchen");
    }
  };

  const handleEditKitchen = (kitchen) => {
    setFormData({
      kitchen_name: kitchen.kitchen_name,
      contact_person: kitchen.contact_person,
      contact_no: kitchen.contact_no,
      kitchen_address: kitchen.kitchen_address,
      kitchen_location: kitchen.kitchen_location,
      user_name: kitchen.user_name,
      password: kitchen.password,
      district: kitchen.district,
      state: kitchen.state,
    });
    setSelectedKitchenIdForEdit(kitchen.kitchen_id);
    setEditMode(true);
    const modal = new window.bootstrap.Modal(
      document.getElementById("addKitchenModal")
    );
    modal.show();
  };

  const handleDeleteKitchen = async (id) => {
    if (window.confirm("Are you sure you want to delete this kitchen?")) {
      try {
        await axios.delete(
          `https://ims-backend.indevconsultancy.in/api/kitchens/${id}/`
        );
        alert("Kitchen deleted successfully!");
        fetchData();
      } catch (error) {
        console.error("Error deleting kitchen:", error);
        alert("Failed to delete kitchen");
      }
    }
  };

  return (
    <div className="container-fluid mt-4">
      <div className="card">
        <div className="card-header">
          <div className="row g-3 align-items-center">
            <div className="col-lg-4">
              <h5 className="mb-0">Kitchen List</h5>
            </div>
            <div className="col-lg-4">
              <input
                type="text"
                className="form-control"
                placeholder="Search by kitchen name"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            <div className="col-lg-4 text-end">
              <button
                className="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#addKitchenModal"
              >
                Add Kitchen
              </button>
            </div>
          </div>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-bordered table-striped text-center">
              <thead className="bg-primary text-white">
                <tr>
                  <th>S.No.</th>
                  <th>Kitchen Name</th>
                  <th>Contact Person</th>
                  <th>Contact No</th>
                  <th>Address</th>
                  <th>Location</th>
                  <th>District</th>
                  <th>State</th>
                  {/* <th>Assigned Operator</th> */}
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="9">Loading...</td>
                  </tr>
                ) : filteredKitchens.length === 0 ? (
                  <tr>
                    <td colSpan="9">No kitchens found.</td>
                  </tr>
                ) : (
                  // filteredKitchens
                  //   .filter((kitchen) => kitchen.kitchen_id !== null)
                  //   .map((kitchen) => (
                  //     <tr key={kitchen.kitchen_id}>
                  paginatedKitchens
                    .filter((kitchen) => kitchen.kitchen_id !== null)
                    .map((kitchen, index) => (
                      <tr key={kitchen.kitchen_id}>
                        <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>

                        {/* <td>{kitchen.kitchen_id}</td> */}
                        <td>{kitchen.kitchen_name}</td>
                        <td>{kitchen.contact_person}</td>
                        <td>{kitchen.contact_no}</td>
                        <td>{kitchen.kitchen_address}</td>
                        <td>{kitchen.kitchen_location}</td>
                        <td>{kitchen.district_name}</td>
                        <td>{kitchen.state_name}</td>
                        {/* <td>
                          {getAssignedOperatorName(kitchen.kitchen_id) ? (
                            getAssignedOperatorName(kitchen.kitchen_id)
                          ) : (
                            <button
                              className="btn btn-sm btn-primary"
                              onClick={() =>
                                handleAssignClick(kitchen.kitchen_id)
                              }
                            >
                              Assign
                            </button>
                          )}
                        </td> */}
                        <td>
                          <button
                            className="btn btn-sm text-white me-2"
                            style={{ background: "#28a745" }}
                            onClick={() => handleEditKitchen(kitchen)}
                          >
                            Edit
                          </button>
                          <button
                            className="btn btn-sm text-white"
                            style={{ background: "#8b1a1a" }}
                            onClick={() =>
                              handleDeleteKitchen(kitchen.kitchen_id)
                            }
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))
                )}
              </tbody>
            </table>
          </div>

          <div className="d-flex justify-content-between align-items-center mt-3">
            <button
              className="btn btn-outline-primary btn-sm"
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
            >
              Previous
            </button>
            <span>
              Page {currentPage} of {totalPages}
            </span>
            <button
              className="btn btn-outline-primary btn-sm"
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        </div>
      </div>

      {/* Assign Modal */}
      {/* <div
        className="modal fade"
        id="assignModal"
        tabIndex="-1"
        aria-labelledby="assignModalLabel"
        aria-hidden="true"
        ref={assignModalRef}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="assignModalLabel">
                Assign Operator
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <select className="form-select" onChange={handleOperatorChange}>
                <option value="">Select Operator</option>
                {operators.map((op) => (
                  <option
                    key={op.Kitchen_operator_id}
                    value={op.Kitchen_operator_id}
                  >
                    {op.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" data-bs-dismiss="modal">
                Close
              </button>
              <button className="btn btn-primary" onClick={handleAssignSubmit}>
                Assign
              </button>
            </div>
          </div>
        </div>
      </div> */}

      {/* Add Kitchen Modal */}
      <div
        className="modal fade"
        id="addKitchenModal"
        tabIndex="-1"
        aria-labelledby="addKitchenModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <form onSubmit={handleAddKitchen}>
              <div className="modal-header">
                <h5 className="modal-title" id="addKitchenModalLabel">
                  {editMode ? "Edit Kitchen" : "Add Kitchen"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <div className="row g-3">
                  <div className="col-md-6">
                    <input
                      type="text"
                      className="form-control"
                      name="kitchen_name"
                      placeholder="Kitchen Name"
                      value={formData.kitchen_name}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <input
                      type="text"
                      className="form-control"
                      name="contact_person"
                      placeholder="Contact Person"
                      value={formData.contact_person}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <input
                      type="text"
                      className="form-control"
                      name="contact_no"
                      placeholder="Contact No"
                      value={formData.contact_no}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <input
                      type="text"
                      className="form-control"
                      name="kitchen_address"
                      placeholder="Address"
                      value={formData.kitchen_address}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <input
                      type="text"
                      className="form-control"
                      name="kitchen_location"
                      placeholder="Location"
                      value={formData.kitchen_location}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <input
                      type="hidden"
                      className="form-control"
                      name="district"
                      placeholder="District ID"
                      value="1"
                      onChange={handleInputChange}
                      required
                    />
                    <input
                      type="text"
                      className="form-control"
                      name="user_name"
                      placeholder="Username..."
                      value={formData.user_name}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <input
                      type="hidden"
                      className="form-control"
                      name="state"
                      placeholder="District ID"
                      value="1"
                      onChange={handleInputChange}
                      required
                    />
                    <input
                      type="text"
                      className="form-control"
                      name="password"
                      placeholder="Password.."
                      value={formData.password}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button type="submit" className="btn btn-primary">
                  {editMode ? "Update Kitchen" : "Save Kitchen"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KitchenList;
